<template>
<!-- 查看渠道商联系等信息弹窗 -->
  <div class="switch-project-wrapper c-pl-SwitchProject">
    <!-- 切换项目的dialog -->
    <el-dialog
      title="渠道商联系信息"
      :visible.sync="centerDialogVisible"
      :before-close="handleClose"
      width="62.5rem"
      center
    >
     <div v-if="isSelect">
  <div>
    <span v-text="'名称:   '+channel.channelName" ></span>
    <el-divider></el-divider>
    <span v-text="'联系电话:   '+channel.phone"></span>
    <el-divider></el-divider>
    <span v-text="'邮箱:   '+channel.email"></span>
  </div>
     </div>
    </el-dialog>
  </div>
</template>
<script>
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
export default {
  name: 'SwitchChannel',
  props: ['show'],
  data () {
    return {
      centerDialogVisible: false,
      isSelect: false,
      channel: {},
    }
  },
  created(){
    this.isSelect=true
  },
  mounted () {
      if (this.isSelect) {
      this.ChannelFindInfo()
      }

  },
  watch: {
    show: function (val) {
      this.centerDialogVisible = val
    },
    centerDialogVisible () {
      console.log(this.centerDialogVisible)
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('onChannel', { isSelect: true })
      done()
    },
       ChannelFindInfo(){
      let data = {
        channelNo: localStorage.getItem('c_no')
      }
      CHANNEL_INFO_API.ChannelFindInfo(data).then(res => {
      console.log(res)
      this.channel=res.data
      })
 },   
      
      
  }
}
</script>
